export var BottomBarDLSType;
(function (BottomBarDLSType) {
    /*
     ----- LAYOUT TYPE A (WITH BORDER SHADOW) ----
        Typography
        {children}
        Button
    */
    BottomBarDLSType["TYPE_A"] = "TYPE_A";
    /*
    ----- LAYOUT TYPE B (WITH BORDER SHADOW) ----
       Button
       Typography
       {children}
    */
    BottomBarDLSType["TYPE_B"] = "TYPE_B";
    /*
     ----- LAYOUT TYPE C (WITH NO BORDER SHADOW) ----
       Button
       Typography
       {children}
    */
    BottomBarDLSType["TYPE_C"] = "TYPE_C";
    /*
    ----- LAYOUT TYPE DEFAULT (WITH NO BORDER SHADOW) ----
      Typography
      {children}
      Button
    */
    BottomBarDLSType["DEFAULT"] = "DEFAULT";
})(BottomBarDLSType || (BottomBarDLSType = {}));
